<template>
  <div class="q-pt-md q-mt-lg">
    <q-table
      flat
      table-header-class="bg-accent text-width-bold"
      title="Produtos Selecionados"
      :rows="rows"
      :columns="columns"
      no-data-label="Nenhum produto selecionado."
      class="tabela-tamanho-fixo"
      dense
      hide-pagination
      :rows-per-page-options="[0]"
    >
      <template #body-cell-delete="props">
        <q-td>
          <q-btn
            @click="deleteId(props.row.id)"
            color="negative"
            round
            icon="delete"
          />
        </q-td>
      </template>
      <template #body-cell-total="props">
        <q-td>
          <q-input
            dense
            outlined
            v-model="props.row.destino"
            label="Quantidade"
          />
        </q-td>
      </template>
      <template #body-cell-remover="props">
        <q-td>
          <q-btn
            color="red"
            round
            flat
            icon="delete"
            @click="removerSelecionado(props.pageIndex)"
          />
        </q-td>
      </template>
    </q-table>
  </div>
</template>

<script>
const columns = [
  {
    name: "codigo",
    label: "Codigo",
    field: "codigo",
    align: "left",
  },
  {
    name: "contract_product_description",
    label: "Descrição",
    field: "contract_product_description",
    align: "left",
  },
  {
    name: "localizacao",
    label: "Loca. Origem",
    field: "localizacao",
    align: "left",
  },
  {
    name: "localizacao",
    label: "Loca. Destino",
    field: "localizacao",
    align: "left",
  },
  {
    name: "quantidade",
    label: "Qtd. em Estoque",
    field: "quantidade",
    align: "left",
  },
  {
    name: "total",
    label: "Qtd a transferir",
    field: "total",
    align: "left",
  },
  {
    name: "remover",
    label: "Remover",
    field: "remover",
    align: "left",
  },
];

import { ref, watch } from "vue";

export default {
  props: ["data", "transferir"],
  setup(props, { emit }) {
    const rows = ref([]);
    const disable = ref(true);

    watch(
      () => props.data,
      () => {
        props.data.length == 0
          ? (disable.value = true)
          : (disable.value = false);

        rows.value = props.data;
      }
    );

    const removerSelecionado = async (index) => {
      rows.value.splice(index, 1);
    };

    watch(
      () => props.transferir,
      () => {
        emit("selecionadosRows", rows.value);

        let largura = rows.value.length;
        setTimeout(() => {
          rows.value.splice(0, largura);
        }, 500);
      }
    );

    return {
      columns,
      rows,
      disable,
      removerSelecionado,
    };
  },
};
</script>

<style></style>
